module.exports = "/assets/e25318744e31f44908b753ca67d4e879.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/I2.png
// module id = 1459
// module chunks = 0